<template>
  <div class="w-full h-full p-4">
    <div class="w-full flex justify-end">
      <div
        class="text-base-70 hover:text-primary-90 cursor-pointer"
        @click="closePanel"
        name="ai-chatbot-iframe-error-close"
        v-aha-emit-action
      >
        <aha-icon
          name="close"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        />
      </div>
    </div>
    <div class="w-full h-full flex flex-col items-center justify-center">
      <img :src="ErrorIllustration" />
      <p class="mt-4 text-center">
        {{ $i18nPresenter.t('Your Slide Sidekick needs a moment.') }}
      </p>
      <p class="mt-1 text-center">
        {{ $i18nPresenter.t('A quick refresh might help.') }}
      </p>
      <aha-antd-button
        class="mt-4"
        variant="secondary"
        @click="refresh"
        name="ai-chatbot-iframe-error-refresh"
        v-aha-emit-action
      >
        {{ $i18nPresenter.t('Refresh') }}
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
import ErrorIllustration from '@/assets/images/aha-ai/ErrorIllustration.svg'
import utils from '@/util'

export default {
  data() {
    return {
      ErrorIllustration,
    }
  },

  created() {
    utils.preloadImage({ url: ErrorIllustration })
  },

  methods: {
    refresh() {
      this.$emit('refresh')
    },

    closePanel() {
      this.$emit('closePanel')
    },
  },
}
</script>
